/*@ngInject*/
const UserActionMediator = function (userActionRepository) {

    this.deactivateUser = function (userId) {
        return userActionRepository.deactivateUser(userId);
    };

    this.activateUser = function (userId) {
        return userActionRepository.activateUser(userId);
    };

    this.deleteUser = function (userId) {
        return userActionRepository.deleteUser(userId);
    };

    this.resetPassword = function (userId) {
        return userActionRepository.resetPassword(userId);
    };

    this.unlockUser = function (userId) {
        return userActionRepository.unlockUser(userId);
    };

    this.getFormSetId = function (userId) {
        return userActionRepository.getFormSetId(userId);
    };
};

angular.module('umCore')
    .service('userActionMediator', UserActionMediator);
